import './scss/_fonts.scss';
import '../../wwwroot/css/icons/material/styles.min.css';
import '../../wwwroot/css/icons/icomoon/styles.min.css';
import "./scss/main.scss";

import * as modal from './js/modal';
import * as header from './js/header';
import * as search from './js/search';
import * as stickyHeader from '../js/sticky-header';
import * as sitemap from './js/sitemap';
import * as svg from './js/svg';
import * as firebaseService from "../js/firebase.service";

window.firebaseService = firebaseService;

modal.initModal();
header.initHeader();
search.initSearch();
stickyHeader.initStickyHeader();
sitemap.initSitemap();
svg.initSVGLoading();
